import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const MindblownIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#FFCB4C"
        d="M70 37.2a13.7 13.7 0 0 0-13.7-13.7c-2 0-5.5 1.2-5.5 1.2l-26.3 2.7s-5.4-3.1-8.8-3.1A13.7 13.7 0 0 0 2.1 39.4 34 34 0 0 0 70 38v-.8Z"
      />
      <path
        fill="#F19020"
        d="M60.3 27.5c-2-.5-2 .8-4.5.5-2.3-.3 1-1.5-.3-2.2-.5-.2-1-.3-1.8-.2-2.1.3-34 1.1-35.1 1.7-1 .5-1.7 1-2.6.2-1.2-1.1-3-.5-3.5-.1-.6.5-.7 1.4.5 2.5a17.7 17.7 0 0 0 8 2.5c2.4 0 2.8-3.4 6.2-3.5 2.3 0 22.3 2.2 24 2l.6-.1c3.2 0 3.9 2.9 7.2.6 1.4-1.1 3.6-3.3 1.3-3.9Z"
      />
      <path
        fill="#F36C24"
        d="M11.9 18.2a40.3 40.3 0 0 1 9 14.2c2.5 0 2.9-1.4 6.3-1.5 2.3 0 3.6 1.6 5.3 2.5 3 1.6 5.1-1.5 7.4-1.5 1.7 0 4.5 2.4 6.4 1.5 2.7-1.2 3.2-2.3 4.9-2.6.6-1.5 1.5-3.4 2.5-5.2 1.5-2.6 3.3-5.3 5.7-7.4H11.9Z"
      />
      <path
        fill="#CE5C1F"
        d="M58.6 18.9c2.6-2.6-46 0-44.7 1.5 2 2.2 4.4 6.4 4.4 6.4s9.5 4.8 16.7-1.3c5 3 12 2 15.2-3.2 0 0 2.4.9 4.9 1 0 0 1.9-2.8 3.5-4.4Z"
      />
      <path
        fill="#65471B"
        d="M36 67.2c4.8 0 8.7-4.5 8.7-10 0-5.4-4-9.8-8.7-9.8-4.8 0-8.7 4.4-8.7 9.9 0 5.4 4 9.9 8.7 9.9ZM28 41.2c0 3-1.8 5.3-4 5.3s-4-2.3-4-5.3 1.8-5.3 4-5.3 4 2.4 4 5.3Zm24 0c0 3-1.8 5.3-4 5.3s-4-2.3-4-5.3 1.8-5.3 4-5.3 4 2.4 4 5.3Z"
      />
      <path
        fill="#CCD6DD"
        d="M62.3 7.5c-.5 0-1 0-1.4.2A7.5 7.5 0 0 0 55 4.9h-.5a8 8 0 0 0-13 1.4 4.5 4.5 0 0 0-7.6-1 7.5 7.5 0 0 0-13.4-1.6h-1.1a7.5 7.5 0 0 0-6.6 4c-.4-.2-.8-.2-1.2-.2A6.8 6.8 0 1 0 14.9 20a4.5 4.5 0 0 0 3.5.9 9.7 9.7 0 0 0 16.4.1 7.8 7.8 0 0 0 13.6-2.9h.2a8 8 0 0 0 1.7-.1 7.4 7.4 0 0 0 10.6-1 4.9 4.9 0 0 0 3.2-.2 5 5 0 0 0-1.8-9.4Z"
      />
      <path
        fill="#E1E8ED"
        d="M55.6 15.8a4.2 4.2 0 1 0 0-8.5 4.2 4.2 0 0 0 0 8.5ZM39.8 11.8A4.3 4.3 0 0 0 33.4 8a3.3 3.3 0 0 0-5.8-.6A7.5 7.5 0 0 0 15.2 11a4 4 0 1 0 .5 5 7.5 7.5 0 0 0 5.5 4.3 4.5 4.5 0 0 0 8.3-1.3 4.5 4.5 0 0 0 6.6-3 4.3 4.3 0 0 0 3.7-4.2Z"
      />
    </Icon>
  );
};

export default MindblownIcon;
